"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../../stitches.config");

var _ImageOrLottie = _interopRequireDefault(require("../image-or-lottie/ImageOrLottie"));

var _sharedStyles = require("../sharedStyles");

var SectionTitle = (0, _stitches.styled)(_sharedStyles.Title, {
  fontSize: '30px' // not a stitches defined font cause we don't care about consistency of sizing

});
var StyledSection = (0, _stitches.styled)('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '35px',
  maxWidth: '500px'
});
/**
 * An interstitial page that can be used to split up questions.
 */

var Section = function Section(_ref) {
  var image = _ref.image,
      title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(StyledSection, null, /*#__PURE__*/_react.default.createElement(SectionTitle, null, title), /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, Object.assign({
    css: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '20px',
      width: 'fit-content'
    }
  }, image)));
};

Section.defaultProps = {
  image: {},
  title: ''
};
var _default = Section;
exports.default = _default;